import { VFlex } from '@/package';

import CollectionFileProgress from './CollectionFileProgress';

type FileItem = {
  error?: Nullish<Error>;
  name: string;
  status: 'pending' | 'canceled' | 'error' | 'done' | 'progress';
  isDir?: boolean;
};

const CollectionFileProgressPopup = ({
  downloadingItemList,
  enableCancelUpload,
  uploadingItemList,
  clearDownloadFileStatusMap,
  clearUploadFileStatusMap,
  onUploadCancel,
}: {
  downloadingItemList: FileItem[];
  enableCancelUpload: boolean;
  uploadingItemList: FileItem[];
  clearDownloadFileStatusMap: () => void;
  clearUploadFileStatusMap: () => void;
  onUploadCancel?: () => void;
}) => {
  return (
    <VFlex className="fixed right-4 bottom-4 z-[4000]" items="end" gap={0.5}>
      {downloadingItemList.length ? (
        <CollectionFileProgress
          type="download"
          itemList={downloadingItemList}
          onCloseClick={() => {
            clearDownloadFileStatusMap();
          }}
        />
      ) : (
        void 0
      )}

      {uploadingItemList.length ? (
        <CollectionFileProgress
          enableCancelUpload={enableCancelUpload}
          type="upload"
          itemList={uploadingItemList}
          onCloseClick={() => {
            clearUploadFileStatusMap();
          }}
          onUploadCancel={onUploadCancel}
        />
      ) : null}
    </VFlex>
  );
};

export default CollectionFileProgressPopup;
